import Map from 'eemovel-map-library/src/data/google-maps/map';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import ClusterIcon from '../../../../assets/img/Ellipse_39.svg';
import Icon from '../../../../assets/img/CIRCLE-red-border.svg';
import { loading, loaded } from '../../../../layout/redux/layoutActions';
import {
  setIsLoadingMap,
  updateClusters,
  updateMarkers,
} from '../../redux/dashboardActions';
import { infoWindowRealtyOffersPrimary } from './offersPrimary.infowindow';
import api from '../../../../helpers/api';
import {
  generateBuildingDetailsModal,
  generateInfoWindow,
} from './offersPrimary.controller';

// TODO
// APRIMORAR ARQUITETURA
// IMPLEMENTAR PADRÃO DE PROJETO FACTORY

export const generateMarkersOnMap = (geometry, type) => {
  return (dispatch) => {
    const google = window.google;
    const mappedCoordinates = geometry.map((el) => ({
      coordinates: new google.maps.LatLng(
        el.location_point[0],
        el.location_point[1]
      ),
      rgi: el.rgi,
    }));
    const markers = mappedCoordinates.map((el, index) => {
      const marker = new google.maps.Marker({
        position: el.coordinates,
        map: Map.map,
        icon: Icon,
      });
      if (type === 'primary') {
        marker.addListener('click', function () {
          dispatch(generateInfoWindow(el?.rgi, marker));
        });
      }
      return marker;
    });
    const clusterOptions = {
      styles: [
        {
          url: ClusterIcon,
          height: 24,
          width: 24,
          textColor: '#FFF',
          fontWeight: 400,
          textSize: 14,
          anchorText: [5, 0],
        },
      ],
    };

    const map = Map.map;
    const markerCluster = new MarkerClusterer(map, markers, clusterOptions);
    dispatch(updateMarkers(markers));
    dispatch(updateClusters(markerCluster));
  };
};

export const createOpenInfoWindow = ({ data, marker, rgi }) => {
  const google = window.google;
  const infowindow = new google.maps.InfoWindow({
    content: infoWindowRealtyOffersPrimary({ payload: data, rgi }),
    maxWidth: '800px',
    zIndex: 5,
  });
  infowindow.open(Map.map, marker);
  return infowindow;
};

const primaryMarketInfoWindows = [];

export const addIWListener = (payload) => {
  return (dispatch) => {
    const map = document.getElementById('mapsToRender');

    const listener = (e) => {
      const split = e?.srcElement?.id?.split(',');
      if (split[0] === 'IWButton' && split[1] === payload?.rgi) {
        dispatch(generateBuildingDetailsModal(payload));
      }
    };
    map.removeEventListener('click', listener);
    map.addEventListener('click', listener);
  };
};
